{
  "title": "ਕੀ ਤੁਹਾਡੇ ਟਿਕਾਣੇ ਤੱਕ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦਿੱਤੀ ਜਾਵੇ?",
  "body": "ਤੁਹਾਡੇ ਟਿਕਾਣੇ ਤੱਕ ਪਹੁੰਚ ਦੀ ਇਜਾਜ਼ਤ ਦੇ ਕੇ ਅਸੀਂ ਯਕੀਨੀ ਬਣਾ ਸਕਦੇ ਹਾਂ ਕਿ ਤੁਸੀਂ ਚੈੱਕ-ਇਨ ਲਈ ਸਹੂਲਤ 'ਤੇ ਪਹੁੰਚ ਗਏ ਹੋ",
  "disagree": "ਅਸਹਿਮਤ",
  "agree": "ਸਹਿਮਤ"
}
